import { useState } from "react";
import { injectIntl } from "react-intl";
import { MenuItem } from "react-bootstrap";
import {
  ItemMenu,
  ListItem,
  ConfirmationModal,
  withApi,
  withBrowser,
  withNotifier,
  apiShape,
  browserShape,
  intlShape,
  notifierShape,
  concatValues,
} from "lcm-iot-commons";

type OwnProps = {
  api: apiShape;
  browser: browserShape;
  intl: intlShape;
  notifier: notifierShape;
  removeCustomer?: $TSFixMeFunction;
  customer: {
    id?: number | string;
    name?: string;
    number?: string;
    address?: {
      city?: string;
      first_name?: string;
      last_name?: string;
    };
  };
};

const defaultProps: Partial<OwnProps> = {
  // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type '$TSFixMeFun... Remove this comment to see the full error message
  removeCustomer: null,
};

type Props = OwnProps & typeof defaultProps;

export function ResellerCustomerItem({
  customer,
  api,
  browser,
  intl,
  notifier,
  removeCustomer,
}: Props) {
  const [deleting, setDeleting] = useState(false);
  const [accessRights, setAccessRights] = useState();

  const handleConfirm = async () => {
    try {
      await (api as $TSFixMe).delete(`/customers/${(customer as $TSFixMe).id}`);
      setDeleting(false);
      if (removeCustomer) await removeCustomer((customer as $TSFixMe).id);
      (notifier as $TSFixMe).showSuccess(
        (intl as $TSFixMe).formatMessage({
          id: "reseller_customer.delete.notification",
        }),
      );
    } catch (error) {
      setDeleting(false);
      (notifier as $TSFixMe).showError((api as $TSFixMe).translateError(error));
    }
  };

  const modalDeleting = deleting ? (
    <ConfirmationModal
      id="customer-item-confirm"
      show
      titleText={(intl as $TSFixMe).formatMessage({
        id: "reseller_customer.delete.modal_title",
      })}
      messageText={(intl as $TSFixMe).formatMessage({
        id: "reseller_customer.delete.modal_message",
      })}
      onConfirm={() => handleConfirm()}
      onClose={() => setDeleting(false)}
    />
  ) : null;

  const itemMenuOpened = async () => {
    /* istanbul ignore next */
    if (!accessRights) {
      try {
        const apiResponse = await (api as $TSFixMe).get(
          "/users/current/access_rights",
          {
            permitable_type: "Customer",
            permitable_id: (customer as $TSFixMe).id,
          },
        );
        setAccessRights(apiResponse);
      } catch (error) {
        (notifier as $TSFixMe).showError(
          (api as $TSFixMe).translateError(error),
        );
      }
    }
  };

  const actions = (
    <div id="customer-action-items">
      <ItemMenu onOpen={itemMenuOpened}>
        <>
          <MenuItem
            id="item-edit"
            onSelect={() =>
              (browser as $TSFixMe).navigateTo(
                `/reseller/customers/${(customer as $TSFixMe).id}/edit`,
              )
            }
            disabled={!(accessRights as $TSFixMe)?.can_update}
          >
            {(intl as $TSFixMe).formatMessage({ id: "button.edit" })}
          </MenuItem>
          <MenuItem
            id="item-delete"
            onSelect={() => setDeleting(true)}
            disabled={!(accessRights as $TSFixMe)?.can_delete}
          >
            {(intl as $TSFixMe).formatMessage({ id: "button.delete" })}
          </MenuItem>
        </>
      </ItemMenu>
      {modalDeleting}
    </div>
  );

  const combineDescription = () => {
    let description = "";
    if ((customer as $TSFixMe).address) {
      const contactName = concatValues(
        [
          (customer as $TSFixMe).address?.first_name,
          (customer as $TSFixMe).address?.last_name,
        ],
        " ",
      );
      if (contactName.length !== 0) {
        description = concatValues(
          [contactName, (customer as $TSFixMe).address.city],
          " - ",
        );
      } else {
        description = (customer as $TSFixMe).address.city;
      }
    }
    return description;
  };

  return (
    <ListItem
      id={`customer-item-${(customer as $TSFixMe).id}`}
      icon="lcm-iot-icon-user"
      title={concatValues(
        [`${(customer as $TSFixMe).number}`, (customer as $TSFixMe).name],
        " - ",
      )}
      description={combineDescription()}
      onClick={() =>
        (browser as $TSFixMe).navigateTo(
          `/reseller/customers/${(customer as $TSFixMe).id}`,
        )
      }
      actions={actions}
      // @ts-expect-error TS(2322) FIXME: Type '{ id: string; icon: string; title: any; desc... Remove this comment to see the full error message
      showItemMenu
    />
  );
}

ResellerCustomerItem.defaultProps = defaultProps;

export default injectIntl(
  withBrowser(withApi(withNotifier(ResellerCustomerItem))),
);
